var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.087,
    height: 16.869,
    viewBox: "0 0 9.087 16.869",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__next",
    transform: "translate(-102.297)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_819",
    "data-name": "Group 819",
    transform: "translate(102.297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_852",
    fill: "#000",
    d: "M111.194 7.972L103.4.183a.649.649 0 0 0-.918.918l7.33 7.33-7.33 7.33a.649.649 0 1 0 .918.918l7.789-7.789a.649.649 0 0 0 .005-.918z",
    "data-name": "Path 852",
    transform: "translate(-102.297)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.b778da49aca00704ca78bcda309ef4bf.svg";
export { ForwardRef as ReactComponent };